import { useRef, useState, useEffect } from "react";
import CHEVRON from "../../../assets/chevron-up.png";

export default function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  const answerRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (isOpen) {
      setHeight(`${answerRef.current.scrollHeight}px`);
    } else {
      setHeight(`${answerRef.current.scrollHeight}px`);
      requestAnimationFrame(() => setHeight("0px"));
    }
  }, [isOpen]);

  return (
    <div
      className="accordinItem"
      style={{
        gap: isOpen ? "20px" : "0px",
        transition: "gap 0.3s ease-in-out"
      }}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="accordinQuestionContainer">
        <span className="accordinQuestion">{question}</span>
        <img
          src={CHEVRON}
          alt="chevron"
          width={24}
          height={24}
          className={`chevron ${isOpen ? "rotate" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      <span
        ref={answerRef}
        className="accordinAnswer"
        style={{
          display: "block",
          height: height,
          opacity: isOpen ? 1 : 0,
          overflow: "hidden",
          transition: "height 0.3s ease-in-out, opacity 0.3s ease-in-out"
        }}
      >
        {answer}
      </span>
    </div>
  );
}
